<template>
    <div class="xigcheck-doc">
        <h1 class="page-title">XigCheck Refund Policy</h1>
        <p class="desc-text">Effective Date: August 5, 2025</p>

        <section class="content-section">
            <h2 class="section-title">1. Authentication Service Fee</h2>
            <p class="desc-text">An authentication service fee may be charged for optional authentication review services for eligible product categories.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">2. Refund Eligibility</h2>
            <p class="desc-text">We may consider refund requests in certain circumstances, including:</p>
            <ul class="policy-list">
                <li>Duplicate charges</li>
                <li>Technical processing errors</li>
                <li>Submission failure due to platform system issues</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">3. Non-Refundable Circumstances</h2>
            <p class="desc-text">The authentication service fee is generally non-refundable in the following situations:</p>
            <ul class="policy-list">
                <li>The authentication review process has been initiated</li>
                <li>The authentication analysis has been completed</li>
                <li>Expert verification resources have been allocated</li>
            </ul>
            <p class="desc-text">Authentication fees are service fees and do not represent insurance, financial protection, or transaction guarantees.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">4. Dispute Submission</h2>
            <p class="desc-text">Users can submit authentication-related disputes through the officially supported channels on the XigFor platform.</p>
            <p class="desc-text">XigCheck may review relevant materials and transaction information when assessing disputes.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">5. Payment Processing</h2>
            <p class="desc-text">All payment processing and refunds are handled through approved third-party payment service providers.</p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'XigcheckRefundPolicy'
}
</script>

<style scoped>
@import './xigcheck-doc.css';
</style>
